import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";


import "./style.scss";

const Footer = () => {
  const [open, setOpen] = useState(false);
  return (
    <footer className="siteFooter">

      <div className="buttons">
        <div className="inner">
          <ul className="list-unstyled clearfix">
            <li className="list">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(!open);
                }}
                data-toggle="dropdown"
              >
                <span>旅行会社・ロケ・大会</span>
                <div className="icon">
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </a>
              <ul
                className={`dropdown-menu ${open ? "active" : ""}`}
                role="menu"
              >
                <li>
                  <a href="https://www.okayama-kanko.jp/business">旅行会社</a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/school">教育旅行</a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/fc">ロケ・撮影</a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/mice">大会・会議</a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/">観光情報</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/business/library">
                <span>写真・動画ライブラリー</span>
              </a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/contact">
                <span>お問い合わせ</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="upper">
        <div className="inner">
          <ul className="list-unstyled clearfix">
            <li>
              <a href="https://www.okayama-kanko.jp/oky/organization">
                運営組織
              </a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/oky/advertise">広告掲載</a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/link">リンク集</a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/coupon">旅とくクーポン</a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/spot/list?category_x[]=45#searchResultArea">
                ボランティアガイド
              </a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/supporter">
                晴れシェルジュ
              </a>
            </li>
            <li>
              <a
                href="https://www.okayama-ebooks.jp/?page_id=2291"
                rel="external nofollow noreferrer"
                target="_blank"
              >
                パンフレット
              </a>
            </li>
            <li>
              <a href="https://www.okayama-kanko.jp/newsletter">
                メールマガジン
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright">
        <div className="inner">
          Copyright© 公益社団法人 岡山県観光連盟. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
